import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-10/12 space-y-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-600 text-12px" }, [
  /*#__PURE__*/_createTextVNode(" Klik tombol dibawah untuk mengaktifkan komisi. Anda dapat mengubah"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" status kapan saja. ")
], -1)
const _hoisted_4 = { class: "flex flex-row pt-1 text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_6 = { class: "ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_booking_commission_form_criteria_booking = _resolveComponent("booking-commission-form-criteria-booking")!
  const _component_booking_commission_form_commission_rules = _resolveComponent("booking-commission-form-commission-rules")!
  const _component_booking_commission_form_tier_calculation = _resolveComponent("booking-commission-form-tier-calculation")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetail,
      onBack: _ctx.goBack,
      title: "Ubah Komisi Booking",
      "full-page": "",
      "custom-class": "px-0",
      "vertical-separator": false,
      "leave-page-confirmation": _ctx.leavePageConfirmation,
      "onUpdate:leave-page-confirmation": _cache[2] || (_cache[2] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
      onLeavePage: _ctx.onLeavePage
    }, {
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_lp_button, {
            "text-color": "white",
            customClass: "w-full py-2.5",
            title: "Simpan",
            onClick: _ctx.onSaveForm,
            disabled: !_ctx.isFormValid
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_booking_commission_form_criteria_booking, { "form-type": "edit" }),
          _createVNode(_component_booking_commission_form_commission_rules),
          _createVNode(_component_booking_commission_form_tier_calculation, {
            isValid: _ctx.validCalculationTier,
            "onUpdate:isValid": _cache[1] || (_cache[1] = ($event: any) => (_ctx.validCalculationTier = $event))
          }, null, 8, ["isValid"]),
          _createVNode(_component_data_wrapper, {
            class: "text-16px space-y-4",
            label: "Status Komisi"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode("div", _hoisted_4, [
                _createVNode("div", {
                  class: 
                `toggle-switch inline-block cursor-not-allowed ${
                  _ctx.form.commissionStatus === 'active'
                    ? 'toggle-active bg-red-lp-100'
                    : 'bg-gray-lp-200'
                }`
              
                }, [
                  _hoisted_5
                ], 2),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.form.commissionStatus === "active" ? "Aktif" : "Tidak Aktif"), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading", "error", "errorType", "onTryAgain", "onBack", "leave-page-confirmation", "onLeavePage"]),
    (_ctx.saveConfirmation)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.saveBookingCommission,
          onClose: _ctx.closeSaveConfirmation,
          title: "Konfirmasi Perubahan",
          message: 
      `Anda yakin ingin menyimpan perubahan detail Komisi Booking untuk “${_ctx.commissionForName}“ ?`
    ,
          image: "are-you-sure",
          textSuccess: "Simpan",
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "message"]))
      : _createCommentVNode("", true),
    (_ctx.successSave)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onSubmit: _ctx.closeSuccessSave,
          title: "Perubahan Berhasil !",
          message: 
      `Detail Komisi Booking untuk “${_ctx.commissionForName}“ berhasil diubah.`
    ,
          image: "image-modal-success",
          textSuccess: "OK",
          class: "px-8"
        }, null, 8, ["onSubmit", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}